const getCookieList = () => {
    const decodedCookie = decodeURIComponent(document.cookie);
    // Cookies are separated by semicolon (;)
    return decodedCookie.split(";")
}

// Gives true if the cookie passed as parameter exists and false if not
export const hasCookie = (cookieName) => {
    const cookies = getCookieList();
    const name = `${cookieName}=`;
    for(let i = 0; i < cookies.length; i++){
        let c = cookies[i];
        //Remove white-spaces at the beginning of the cookie.
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return true;
        }
    }
    return false;
};

export const getCookie = (cookieName) => {
    const cookies = getCookieList();
    const name = `${cookieName}=`;
    for(let i = 0; i < cookies.length; i++){
        let c = cookies[i];
        //Remove white-spaces at the beginning of the cookie.
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
};

export const setCookie = (cookieName, cookieValue, expirationDays) => {
    const d = new Date();
    d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cookieName}=${cookieValue};${expires};path=/`;
};

export const deleteCookie = (cookieName) => {
    // document.cookie = cookieName + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = cookieName+'=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;';
    document.cookie = cookieName+'=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=.www.darwinex.com;';
    document.cookie = cookieName+'=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=.www.darwinex.cn;';
    document.cookie = cookieName+'=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=.predx.darwinex.com';
};
